import * as React from 'react';



export default class Bell extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <path id="Fill-1" className="strokeColor" stroke="currentColor" fill="currentColor" d="M8.1,0.4c0,0,3.3,1.3,3.6,4.5c0.3,3.2,0.3,6.3,0.3,6.3h2c0,0,0.9-0.3,0.4-1.3c0,0-0.2-0.3-1-0.5 l-0.2-3.9c0,0-0.1-4.3-4.2-5.1L8.1,0.4z" />
        <path id="Stroke-3" className="st1" d="M9.9,12.8c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2" />
        <path id="Stroke-5" className="st1" d="M13.1,9.1V5.8c0-2.9-2.2-5.3-5.1-5.4c-3-0.1-5.4,2.3-5.4,5.2v3.5c0,0.3-0.2,0.5-0.5,0.5 c-0.4,0-0.8,0.3-0.8,0.8v0.1c0,0.4,0.3,0.8,0.8,0.8h0.5h10.4h0.5c0.4,0,0.8-0.3,0.8-0.8v-0.1c0-0.4-0.3-0.8-0.8-0.8 C13.4,9.6,13.1,9.4,13.1,9.1z" />
      </svg>
    )
  }
}
